import React from "react";
import Layout from 'layout/index.js'

import { Link } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';


import { authenticationService } from 'auth/authenticationService'
import {
          Paper,
          Box,
          Button,
          Typography,
          Alert,
          TextField,
          TableSortLabel,TablePagination,TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          FormControl, InputLabel, Select, MenuItem, 
          CircularProgress,
          // FormHelperText,

        } from '@mui/material';
  
const headCells = [
  { id: "created_at", numeric: false, disablePadding: false, label: "Fecha creación", sorting: true},
  { id: "patente", numeric: false,disablePadding: false,label: "Patente", sorting: true},
  { id: "tipo", numeric: false,disablePadding: false,label: "Tipo", sorting: true},
  { id: "marca", numeric: false,disablePadding: false,label: "Marca", sorting: true},
  { id: "modelo", numeric: false, disablePadding: false, label: "Modelo", sorting: true},
  { id: "color", numeric: false, disablePadding: false, label: "Color", sorting: true},
  { id: "detalles", numeric: false, disablePadding: false, label: "Ver", sorting: false},
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className='hideSort'>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}

function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}

class Vehiculos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
        loading:false
      },
      filters: {
        estado_consolidado:''
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'created_at',
        order:'desc',
      },
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.createNew = this.createNew.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(){
    // console.log(this.state.filters)

    this.setState(prevState => ({
      html: {
        ...prevState.html,
        loading:true
      },
    }));

    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page,
    };

    if(this.state.filters.patente && this.state.filters.patente!==''){
      params['patente'] = this.state.filters.patente;
    }
    if(this.state.filters.estado_consolidado && this.state.filters.estado_consolidado!=='none'){
      params['estado_consolidado'] = this.state.filters.estado_consolidado;
      console.log('alto')
    }
    // console.log(params)
    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url:'/permisos/vehiculo/?'+query,
      method: 'GET',
    })
    .then(result=>{
      let list = false;
      if(result.data.length > 0){
        list=true;
      }
      this.setState(prevState => ({
        pagination: {
            ...prevState.pagination,
            rows_num: result.rows_num
        },
        html: {
          ...prevState.html,
          list: list,
          show_view: true,
          show_credential_error:false,
          loading:false
        },
        objects: result.data
      }));
    })
    .catch(err=>{
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          show_view: false,
          show_credential_error:true,
          loading:false
        },
      }));
    });

  }

  componentDidMount(){
    this.handleLoad();
  }

  createNew(){
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        list: false,
      },
    }));
  }

  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;
    this.setState({ filters: currentState },()=>{
      this.handleLoad();
    });

  }

  render() {
    return (
    <Layout title='Vehículos'>
      
      <Paper>
        <Box p={1} m={1}>

          <Box p={1}>
            <Typography variant='h5'>
              Vehículos
            </Typography>
          </Box>

          <Box p={1}>
            <TextField  name='patente'
                        id='patente'
                        label='Buscar por patente'
                        placeholder='Buscar por patente'
                        fullWidth
                        maxLength='100'
                        value={this.state.filters.patente}
                        onChange={this.handleFilterChange}
                        variant="standard"
                        />
          </Box>
          <Box p={1}>
            <FormControl  fullWidth={true}
                          variant="standard"
                          >
              <InputLabel id="tipo_label">Estado permiso (proceso 2022)</InputLabel>
              <Select labelId="tipo_label"
                      id="estado_consolidado"
                      name="estado_consolidado"
                      value={this.state.filters.estado_consolidado}
                      onChange={this.handleFilterChange}
              >
                <MenuItem key='null' value='null'>Todos</MenuItem>
                <MenuItem key='0' value='0'>Secciones por validar</MenuItem>
                <MenuItem key='1' value='1'>Listo para Pago</MenuItem>
                <MenuItem key='2' value='2'>Secciones rechazadas</MenuItem>
                <MenuItem key='3' value='3'>Secciones incompletas</MenuItem>
                <MenuItem key='4' value='4'>Pagado</MenuItem>
                <MenuItem key='5' value='5'>Descartado</MenuItem>
                <MenuItem key='6' value='6'>Pagado 1ª cuota (falta 2ª)</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box>


            {this.state.objects.length>0 && this.state.html.list && !this.state.html.loading &&
            <Box p={1}>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <TableContainer>
                <Table size="small" >
                  <EnhancedTableHead
                    order={this.state.sorting.order}
                    orderBy={this.state.sorting.order_by}
                    onRequestSort={this.handleSort}
                  />
                  <TableBody>
                  {this.state.objects.map((object) => {
                    return(
                      <TableRow key={object.vehiculo_uuid}>
                        <TableCell>
                          {(new Date(object.created_at)).toLocaleDateString('es-CL')}
                        </TableCell>
                        <TableCell>
                          {object.patente}
                        </TableCell>
                        <TableCell>
                          {object.tipo}
                        </TableCell>
                        <TableCell>
                          {object.marca}
                        </TableCell>
                        <TableCell>
                          {object.modelo}
                        </TableCell>
                        <TableCell>
                          {object.color}
                        </TableCell>
                        <TableCell>
                          <Button component={Link} to={'/permisos/administracion_vehiculo/'+object.vehiculo_uuid} color='primary' startIcon={<SearchIcon />}>Ver detalles</Button>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            { this.state.html.loading &&
              <CircularProgress />
            }
            {this.state.objects.length===0 && !this.state.html.loading &&
            <Box>
              <Box p={1}>
                <Alert severity='warning'>
                  No se encontraron vehículos
                </Alert>
              </Box>
              <Box p={1} m={1} align='right'>
                <Button component={Link} to={'/permisos/administracion_vehiculo/new'} color='primary' variant='contained'>Agregar un nuevo vehículo</Button>
              </Box>
            </Box>
            }
          </Box>
        </Box>
      </Paper>

    </Layout>
    );
  }
}

export default Vehiculos;
